<template>
  <div class="permission-denied">
    <h1>401 - 权限不足</h1>
    <p>抱歉，您没有访问该页面的权限。</p>
    <router-link to="/">返回首页</router-link>
  </div>
</template>

<script>
export default {
  // 组件逻辑
}
</script>

<style scoped>
.permission-denied {
  text-align: center;
  margin-top: 50px;
}

.permission-denied h1 {
  font-size: 36px;
  color: #ff0000;
}

.permission-denied p {
  font-size: 18px;
  color: #333;
}

.permission-denied router-link {
  margin-top: 20px;
  font-size: 16px;
  color: #007bff;
  text-decoration: none;
}

.permission-denied router-link:hover {
  text-decoration: underline;
}
</style>
